<template lang="pug">
.new-design
  shForm(title="Nuevo Diseño")
</template>

<script>
import shForm from '@/components/pages/design/Form'

export default {
  name: 'NewDesign',

  components: { shForm }
}
</script>

<style lang="stylus">
.new-design
  position relative
</style>



// WEBPACK FOOTER //
// src/components/pages/design/New.vue